// Shown when a product module is off and the viewer cannot purchase it
// (project admin / operator). Platform superadmin/support see UpgradeCta instead.

import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { usePublicUiLocale } from '../contexts/PublicUiLocaleContext';
import { usePanelThemeMode } from './store/usePanelThemeMode';
import { getCostPanelTheme } from './store/storePanelTheme';

export default function ModuleDisabledNotice({
  moduleName,
  size = 'normal',
  minHeight,
}) {
  const { projectModules: pm } = usePublicUiLocale();
  const themeMode = usePanelThemeMode();
  const panel = getCostPanelTheme('admin', themeMode);
  const compact = size === 'compact';
  const boxMinHeight = minHeight ?? (compact ? 160 : 240);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: boxMinHeight,
        p: compact ? 1.5 : 2,
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: compact ? 480 : 640,
          mx: 'auto',
          p: compact ? 2 : 2.5,
          borderRadius: 2,
          border: panel.border,
          bgcolor: panel.paperBg,
          color: panel.lineLabelColor,
          textAlign: 'center',
        }}
      >
        <LockIcon
          sx={{
            color: panel.subtitleColor,
            fontSize: compact ? 28 : 36,
            mb: 1,
          }}
        />
        <Typography
          variant={compact ? 'subtitle1' : 'h6'}
          sx={{ color: panel.amountColor, fontWeight: 700, mb: 0.75 }}
        >
          {moduleName}
        </Typography>
        <Typography variant="body2" sx={{ color: panel.lineLabelColor, mb: 0.5 }}>
          {pm.moduleNotConnected}
        </Typography>
        <Typography variant="body2" sx={{ color: panel.textPrimary }}>
          {pm.moduleDisabledContactProvider}
        </Typography>
      </Box>
    </Box>
  );
}

ModuleDisabledNotice.propTypes = {
  moduleName: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['compact', 'normal']),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
